import React from "react";
import { Grid2 as Grid } from "@mui/material";
import { withTranslation } from "react-i18next";
import * as PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { channelNamesAndConfig } from "../../../model/slice/channelSlice";
import { getChannelLatestDataForDashboard } from "../../../model/slice/customDashboardSlice";
import { isAnalogChannel } from "../../../constants/channel/config";

const ValueWidget = React.memo(({ chNo }) => {
  const channelNameAndConfig = useSelector(channelNamesAndConfig);
  const nameAndConfigData = channelNameAndConfig.find((e) => e.chNo === chNo);
  const channelLatestData = useSelector(getChannelLatestDataForDashboard);
  const data = channelLatestData.find((channel) => channel.chNo === chNo);
  const dataIsAnalog = isAnalogChannel(nameAndConfigData?.chType);
  const displayData = dataIsAnalog ? data?.inputData : data?.chStatus;
  return (
    <Grid container sx={{ height: "100%", justifyContent: "center" }} direction={"column"}>
      <Grid item size={12} sx={{ display: "flex", justifyContent: "start", alignItems: "start", flexGrow: 1, color: "#fff" }}>{data?.chName}</Grid>
      <Grid item size={12} id={`value-${chNo}`} sx={{  display: "flex", justifyContent: "start", alignItems: "end", fontSize: "24px", color: "#28b6c7", flexGrow: 0.3 }}>
        {displayData ?? "--"} {nameAndConfigData?.unit ?? ""}
      </Grid>
    </Grid>
  );
});

ValueWidget.propTypes = {
  chNo: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default withTranslation()(ValueWidget);
